<template>
  <div class="container cpa-item">
    <UiConfirm
      ref="confirm"
      :width="480"
      :type="confirm.type"
      :action-name="confirm.actionName"
      :close-action-name="confirm.closeActionName"
      :action="confirm.action"
      :data="confirm.data"
      :action-icon="confirm.actionIcon"
      @save="actionConfirm"
    >
      <template v-slot:title>
        <div>
          {{ confirm.title }}
        </div>
      </template>

      <div class="body__wrap">
        <i
          :class="confirm.type"
          class="fas fa-exclamation-triangle t:mr-12"
        />
        <div
          class="body__msg"
          v-html="confirm.msg"
        />
      </div>
    </UiConfirm>
    <div class="t:flex t:justify-between t:items-center">
      <div class="title-wrap">
        <h2 class="title">
          {{ $t(`affiliates.offer_popup.cpa_payout`) }}
        </h2>
      </div>
      <div
        class="card-filter__del"
        @click="confirmPayout"
      >
        <UiIcon
          size="20px"
          name="times"
          class="remove-payout"
          :class="{ disabled: isDisableDeletePayout }"
          color="var(--text-negative)"
        />
      </div>
    </div>
    <div class="cpa-item__payout t:mt-12">
      <div class="cpa-item__payout-block">
        <UiLabel
          class="t:mb-8"
          :label="$t(`affiliates.offer_popup.payout`)"
        />
        <div class="t:flex">
          <UiSelectElement
            v-model="cpa.currency_code"
            class="t:mr-8"
            :disabled="!ableToSetCpa"
            :placeholder="$t('affiliates.filters.country')"
            :list="customerCurrencies"
            size="big"
            option-name-param="code"
            option-label-param="code"
            option-value-param="code"
            filterable
          />
          <UiInput
            v-model="cpa.amount"
            :disabled="!ableToSetCpa"
            error-tooltip
            size="big"
            class="offer-input-cpa"
            :error="errorRule.amount"
          />
        </div>
      </div>
      <div class="cpa-item__payout-block">
        <UiLabel
          class="t:mb-8"
          :label="$t('affiliates.offer_popup.cap_players')"
        />
        <div class="t:flex t:items-center">
          <UiInput
            v-model="cpa.cap_players_count"
            :disabled="!ableToSetCpa"
            placeholder="100"
            size="big"
            class="offer-input-cpa "
            error-tooltip
            :error="errorRule.cap_players_count"
          />
          <div class="t:mr-8 t:ml-8">
            {{ $t('affiliates.offer_popup.per') }}
          </div>
          <UiInput
            v-model="dailyCap"
            size="big"
            placeholder="0"
            :disabled="!ableToSetCpa"
            type="number"
            error-tooltip
            autosize
            :error="errorRule.cap_period_seconds"
            class="offer-input-cpa offer-input-cpa_day"
            :post-text="$t('affiliates.offersView.holdRanges.days')"
          />
        </div>
      </div>
      <div class="cpa-item__payout-block">
        <UiLabel
          class="t:mb-8"
          :label="$t('affiliates.offer_popup.hold')"
        />
        <div class="t:flex">
          <UiInput
            v-model="holdRevShare"
            :disabled="!ableToSetCpa"
            size="big"
            width="120px"
            class="offer-input-cpa offer-input-hold t:mr-8"
            error-tooltip
            :error="errorRule.hold_seconds"
          />
          <UiSelectElement
            v-model="holds.dep"
            class="cpa-item__hold-select"
            :disabled="!ableToSetCpa"
            :placeholder="$t(`affiliates.offer_popup.day`)"
            :list="timeRanges"
            size="big"
          />
        </div>
      </div>
    </div>
    <div class="payment-block t:mt-8">
      <div class="title-wrap">
        <h2 class="title">
          {{ $t(`affiliates.offer_popup.cpa_conditions`) }}
        </h2>
        <ElPopover
          v-model:visible="visible3"
          :disabled="listPayment.length === 0 || !ableToSetCpa"
          :transition="null"
          popper-class="payment-block__rules-list"
          placement="bottom"
          width="200"
          trigger="click"
        >
          <template v-slot:reference>
            <UiButton
              :disabled="listPayment.length === 0 || !ableToSetCpa"
              icon="plus"
              class="payment-block__btn"
              :class="{ 'payment-block__btn-error': errorRule.message }"
            >
              {{ $t(`affiliates.offer_popup.add_condition`) }}
              <UiIcon
                :class="{'open': visible3}"
                class="chevron-btn"
                size="9px"
                name="chevron-left"
                color="#000000"
              />
            </UiButton>
          </template>
          <div class="filters-block__rules-list-wr">
            <p
              v-for="(item, index) in listPayment"
              :key="index"
              @click="visible3 = false; addPayment(item)"
            >
              {{ $t(`affiliates.offersView.filter.rule.${item}`) }}
            </p>
          </div>
        </ElPopover>
      </div>
      <!-- card  deposit-->
      <div v-if="!hasCondition || listPayment.length === defaultListPayment.length">
        <div class="notification t:mb-8">
          <i class="fas fa-info-circle warning" />
          <div class="t:ml-4">
            {{ $t('affiliates.offer_popup.empty_cpa_conditions') }}
          </div>
        </div>
      </div>
      <div
        v-if="listPayment.indexOf('deposits') === -1"
        ref="deposits"
        class="card-filter payment-card deposits"
      >
        <div class="card-filter__header">
          <h2 class="card-filter__title">
            {{ $t(`affiliates.offer_popup.deposits`) }}
          </h2>
          <div
            class="card-filter__del"
            :class="{ 'disabled': !ableToSetCpa }"
            @click="ableToSetCpa && confirmPayment('deposits')"
          >
            <UiIcon
              size="14px"
              substyle="fas"
              name="times"
              color="var(--text-negative)"
            />
          </div>
        </div>
        <div class="card-filter__body">
          <UiRangeInput
            :value="deposits_count"
            :label="$t(`affiliates.offer_popup.deposit_count`)"
            :disabled="!ableToSetCpa"
            class="card-filter__range-input"
            type="number"
            :error="getRuleError('deposits_count')"
            @change="
              $set(cpa, 'deposits_count_min', prepareCpaValue($_.clone($event.min)));
              $set(cpa, 'deposits_count_max', prepareCpaValue($_.clone($event.max)));
            "
          />
          <UiRangeInput
            :value="deposits_sum"
            :label="$t(`affiliates.offer_popup.deposit_sum`)"
            :disabled="!ableToSetCpa"
            error-tooltip
            class="card-filter__range-input"
            type="number"
            :error="getRuleError('deposits_sum')"
            @change="
              $set(cpa, 'deposits_sum_min', prepareCpaValue($_.clone($event.min)));
              $set(cpa, 'deposits_sum_max', prepareCpaValue($_.clone($event.max)));
            "
          />
          <UiRangeInput
            :value="deposits_amount"
            :label="$t(`affiliates.offer_popup.deposit_amount`)"
            :disabled="!ableToSetCpa"
            class="card-filter__range-input"
            error-tooltip
            type="number"
            :error="getRuleError('deposit_amount')"
            @change="
              $set(cpa, 'deposit_amount_min', prepareCpaValue($_.clone($event.min)));
              $set(cpa, 'deposit_amount_max', prepareCpaValue($_.clone($event.max)));
            "
          />
          <div
            v-if="getConditionsError(['deposit_amount', 'name'])"
            class="card-filter__notification notification t:mt-4"
          >
            <i class="fas fa-info-circle warning" />
            <div class="t:ml-4">
              {{ getConditionsError(['deposit_amount', 'name']) }}
            </div>
          </div>
        </div>
      </div>
      <!-- card  deposit-->
      <div
        v-if="listPayment.indexOf('sport_bets') === -1"
        ref="sport_bets"
        class="card-filter payment-card sport_bets"
      >
        <div class="card-filter__header">
          <h2 class="card-filter__title">
            {{ $t(`affiliates.offer_popup.sport_bet`) }}
          </h2>
          <div
            class="card-filter__del"
            :class="{ 'disabled': !ableToSetCpa }"
            @click="ableToSetCpa && confirmPayment('sport_bets')"
          >
            <UiIcon
              size="14px"
              substyle="fas"
              name="times"
              color="var(--text-negative)"
            />
          </div>
        </div>
        <div class="card-filter__body">
          <UiRangeInput
            :value="sport_bets_count"
            :label="$t(`affiliates.offer_popup.bet_count`)"
            :disabled="!ableToSetCpa"
            class="card-filter__range-input"
            error-tooltip
            type="number"
            :error="getRuleError('sport_bets_count')"
            @change="
              $set(cpa, 'sport_bets_count_min', prepareCpaValue($_.clone($event.min)));
              $set(cpa, 'sport_bets_count_max', prepareCpaValue($_.clone($event.max)));
            "
          />
          <UiRangeInput
            :value="sport_bets_sum"
            :label="$t(`affiliates.offer_popup.bet_sum`)"
            :disabled="!ableToSetCpa"
            class="card-filter__range-input"
            error-tooltip
            type="number"
            :error="getRuleError('sport_bets_sum')"
            @change="
              $set(cpa, 'sport_bets_sum_min', prepareCpaValue($_.clone($event.min)));
              $set(cpa, 'sport_bets_sum_max', prepareCpaValue($_.clone($event.max)));
            "
          />
          <UiRangeInput
            :value="sport_bet_amount"
            :label="$t(`affiliates.offer_popup.bet_amount`)"
            :disabled="!ableToSetCpa"
            class="card-filter__range-input"
            error-tooltip
            type="number"
            :error="getRuleError('sport_bet_amount')"
            @change="
              $set(cpa, 'sport_bet_amount_min', prepareCpaValue($_.clone($event.min)));
              $set(cpa, 'sport_bet_amount_max', prepareCpaValue($_.clone($event.max)));
            "
          />
          <UiRangeInput
            :value="sport_bets_odd"
            :label="$t(`affiliates.offer_popup.bet_odd`)"
            :disabled="!ableToSetCpa"
            class="card-filter__range-input"
            error-tooltip
            type="number"
            :error="getRuleError('sport_bets_odd')"
            @change="
              $set(cpa, 'sport_bets_odd_min', prepareCpaValue($_.clone($event.min)));
              $set(cpa, 'sport_bets_odd_max', prepareCpaValue($_.clone($event.max)));
            "
          />
          <div
            v-if="getConditionsError(['sport_bet_amount', 'name'])"
            class="card-filter__notification notification t:mt-4"
          >
            <i class="fas fa-info-circle warning" />
            <div class="t:ml-4">
              {{ getConditionsError(['sport_bet_amount', 'name']) }}
            </div>
          </div>
        </div>
      </div>

      <div
        v-if="listPayment.indexOf('casino_bets') === -1"
        ref="casino_bets"
        class="card-filter payment-card casino_bets"
      >
        <div class="card-filter__header">
          <h2 class="card-filter__title">
            {{ $t(`affiliates.offer_popup.casino_bets`) }}
          </h2>
          <div
            class="card-filter__del"
            :class="{ 'disabled': !ableToSetCpa }"
            @click="ableToSetCpa && confirmPayment('casino_bets')"
          >
            <UiIcon
              size="14px"
              substyle="fas"
              name="times"
              color="var(--text-negative)"
            />
          </div>
        </div>
        <div class="card-filter__body">
          <UiRangeInput
            :value="casino_bets_count"
            :label="$t(`affiliates.offer_popup.bet_count`)"
            :disabled="!ableToSetCpa"
            class="card-filter__range-input"
            error-tooltip
            type="number"
            :error="getRuleError('casino_bets_count')"
            @change="
              $set(cpa, 'casino_bets_count_min', prepareCpaValue($_.clone($event.min)));
              $set(cpa, 'casino_bets_count_max', prepareCpaValue($_.clone($event.max)));
            "
          />
          <UiRangeInput
            :value="casino_bets_sum"
            :label="$t(`affiliates.offer_popup.bet_sum`)"
            :disabled="!ableToSetCpa"
            class="card-filter__range-input"
            error-tooltip
            type="number"
            :error="getRuleError('casino_bets_sum')"
            @change="
              $set(cpa, 'casino_bets_sum_min', prepareCpaValue($_.clone($event.min)));
              $set(cpa, 'casino_bets_sum_max', prepareCpaValue($_.clone($event.max)));
            "
          />
          <UiRangeInput
            :value="casino_bet_amount"
            :label="$t(`affiliates.offer_popup.bet_amount`)"
            :disabled="!ableToSetCpa"
            class="card-filter__range-input"
            error-tooltip
            type="number"
            :error="getRuleError('casino_bet_amount')"
            @change="
              $set(cpa, 'casino_bet_amount_min', prepareCpaValue($_.clone($event.min)));
              $set(cpa, 'casino_bet_amount_max', prepareCpaValue($_.clone($event.max)));
            "
          />
          <div
            v-if="getConditionsError(['casino_bet_amount', 'name'])"
            class="card-filter__notification notification t:mt-4"
          >
            <i class="fas fa-info-circle warning" />
            <div class="t:ml-4">
              {{ getConditionsError(['casino_bet_amount', 'name']) }}
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="isActivityAvailable && listPayment.indexOf('player_activity') === -1"
        ref="activity"
        class="card-filter payment-card"
      >
        <div class="card-filter__header">
          <div class="t:flex t:items-center">
            <h2 class="card-filter__title">
              {{ $t('affiliates.offer_popup.player_activity') }}
            </h2>
            <ActionIcon
              icon="info-circle"
              color="var(--tooltip-icon)"
              class="t:ml-8"
              size="16px"
              :tooltip="$t('affiliates.offer_popup.player_activity_tooltip') "
            />
          </div>
          <div
            class="card-filter__del"
            :class="{ 'disabled': !ableToSetCpa }"
            @click="ableToSetCpa && confirmPayment('player_activity')"
          >
            <UiIcon
              size="14px"
              substyle="fas"
              name="times"
              color="var(--text-negative)"
            />
          </div>
        </div>
        <div class="card-filter__body">
          <div class="t:flex t:items-center">
            <span class="card-filter__label">{{ $t('affiliates.offer_popup.min_interval') }}</span>
            <UiInput
              v-model="player_activity.interval_value"
              placeholder="10"
              size="big"
              class="offer-input offer-input-hold card-filter__input_interval-value t:ml-8"
              error-tooltip
              :error="getConditionsError(['player_activity', 'interval_value'])"
              @update:model-value="$_.set(cpa, ['player_activity', 'interval_value'], prepareCpaValue($event))"
            />
            <UiSelectElement
              v-model="player_activity.interval_unit"
              :placeholder="$t(`affiliates.offer_popup.day`)"
              :list="timeRangesInterval"
              size="big"
              class="card-filter__select_interval-unit t:ml-8"
              :error="getConditionsError(['player_activity', 'interval_unit'])"
              @change="$_.set(cpa, ['player_activity', 'interval_unit'], $event)"
            />
          </div>
          <div class="card-filter__required t:mt-16">
            <span class="card-filter__label">{{ $t('affiliates.offer_popup.required_activities') }}:</span>
            <UiRadioGroup
              v-model="player_activity.event_types_group"
              :options="[
                {
                  label: $t('affiliates.offer_popup.type.default'),
                  value: 'default',
                },
                {
                  label: $t('affiliates.offer_popup.type.all'),
                  value: 'all',
                },
                {
                  label: $t('affiliates.offer_popup.type.selected'),
                  value: 'selected',
                }
              ]"
              @change="$_.set(cpa, ['player_activity', 'event_types_group'], $event)"
            />
          </div>
          <UiCheckboxGroup
            v-model="requiredTypesGroup"
            :disabled="player_activity.event_types_group !== 'selected'"
            :options="[
              {
                label: $t('affiliates.offer_popup.event.registration'),
                value: 'registration',
              },
              {
                label: $t('affiliates.offer_popup.event.deposit'),
                value: 'deposit',
              },
              {
                label: $t('affiliates.offer_popup.event.withdrawal'),
                value: 'withdrawal',
              },
              {
                label: $t('affiliates.offer_popup.event.bet'),
                value: 'bet',
              },
            ]"
            @change="$_.set(cpa, ['player_activity', 'selected_event_types'], $event)"
          />
          <div
            v-if="getConditionsError(['player_activity', 'name']) || getConditionsError(['player_activity', 'selected_event_types'])"
            class="card-filter__notification notification"
          >
            <i class="fas fa-info-circle warning" />
            <div class="t:ml-4">
              {{ getConditionsError(['player_activity', 'name']) || getConditionsError(['player_activity', 'selected_event_types']) }}
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="listPayment.indexOf('player_registration') === -1"
        ref="player_registration"
        class="card-filter payment-card deposits"
      >
        <div class="card-filter__header">
          <h2 class="card-filter__title">
            {{ $t('affiliates.offer_popup.player_registration') }}
          </h2>
          <div
            class="card-filter__del"
            :class="{ 'disabled': !ableToSetCpa }"
            @click="ableToSetCpa && confirmPayment('player_registration')"
          >
            <UiIcon
              size="14px"
              substyle="fas"
              name="times"
              color="var(--text-negative)"
            />
          </div>
        </div>
        <div class="card-filter__body">
          <UiRangeInput
            :value="player_registration"
            :label="$t('affiliates.offer_popup.player_reg')"
            :disabled="!ableToSetCpa"
            class="card-filter__range-input ui-range-input_lower"
            type="number"
            :error="getRuleError('player_registration')"
            @change="
              $set(cpa, 'player_registration_min', prepareCpaValue($_.clone($event.min)));
              $set(cpa, 'player_registration_max', prepareCpaValue($_.clone($event.max)));
            "
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { intervalToDuration } from 'date-fns';
import aclMixin from '@/views/mixins/acl';
import UiRangeInput from '@/components/UIElements/UiRangeInput.vue';
import { config } from '@/config';
import { durationSecondsToDays, getDurationInUnit } from '@/helpers/date-helper';

const isActivityAvailable = ['demo', 'test', 'betwinner', 'betpari'].includes(config.customerId);
const listPayment = ['deposits', 'sport_bets', 'casino_bets', ...(isActivityAvailable ? ['player_activity'] : []), 'player_registration'];

export default {
  name: 'CpaItem',
  components: {
    UiRangeInput,
  },
  mixins: [aclMixin],
  props: {
    indexRule: {
      type: Number,
      required: true,
    },
    customerCurrencies: {
      type: Array,
      default: () => [],
    },
    cpa: {
      type: Object,
      required: true,
    },
    isDisableDeletePayout: {
      type: Boolean,
      default: false,
    },
    errorRule: {
      type: [Array, Object, undefined],
      default() {
        return {};
      },
    },
  },
  emits: ['remove-payout'],

  data() {
    return {
      confirm: {
        title: '',
        msg: '',
        type: 'success',
        actionIcon: 'check',
        action: '',
        actionName: '',
        data: {},
      },
      listPayment: [...listPayment],
      defaultListPayment: [...listPayment],
      isActivityAvailable,
      holds: {
        rev: 'days',
        dep: 'days',
      },
      visible3: false,
      cap_players_count: 0,
      cap_period_seconds: 0,
      dailyCap: 0,
      deposits_count: {
        min: null,
        max: null,
      },
      deposits_sum: {
        min: null,
        max: null,
      },
      deposits_amount: {
        min: null,
        max: null,
      },
      sport_bets_count: {
        min: null,
        max: null,
      },
      sport_bets_sum: {
        min: null,
        max: null,
      },
      sport_bet_amount: {
        min: null,
        max: null,
      },
      sport_bets_odd: {
        min: null,
        max: null,
      },
      casino_bets_count: {
        min: null,
        max: null,
      },
      casino_bets_sum: {
        min: null,
        max: null,
      },
      casino_bet_amount: {
        min: null,
        max: null,
      },
      player_registration: {
        min: null,
        max: null,
      },
      player_activity: {
        interval_value: null,
        interval_unit: 'hours',
        event_types_group: 'default',
        selected_event_types: [],
      },
    };
  },
  computed: {
    timeRanges() {
      return [
        {
          id: 'seconds',
          name: this.$t('affiliates.offersView.holdRanges.seconds'),
        },
        {
          id: 'minutes',
          name: this.$t('affiliates.offersView.holdRanges.minutes'),
        },
        {
          id: 'hours',
          name: this.$t('affiliates.offersView.holdRanges.hours'),
        },
        {
          id: 'days',
          name: this.$t('affiliates.offersView.holdRanges.days'),
        },
      ];
    },
    timeRangesInterval() {
      return [
        {
          id: 'hours',
          name: this.$t('affiliates.offersView.holdRanges.hours'),
        },
        {
          id: 'days',
          name: this.$t('affiliates.offersView.holdRanges.days'),
        },
      ];
    },
    requiredTypesGroup: {
      get() {
        if (this.player_activity.event_types_group === 'default') {
          return ['deposit', 'bet'];
        }

        if (this.player_activity.event_types_group === 'all') {
          return ['bet', 'registration', 'deposit', 'withdrawal'];
        }

        return this.player_activity.selected_event_types;
      },
      set(newValue) {
        this.player_activity.selected_event_types = newValue;
      },
    },
    hasCondition() {
      return Object.values(this.$_.pick(this.cpa, [
        'deposit_amount_max',
        'deposit_amount_min',
        'deposits_sum_min',
        'deposits_sum_max',
        'deposits_count_max',
        'deposits_count_min',
        'sport_bets_odd_max',
        'sport_bets_odd_min',
        'sport_bets_sum_max',
        'sport_bets_sum_min',
        'casino_bets_sum_max',
        'casino_bets_sum_min',
        'sport_bet_amount_max',
        'sport_bet_amount_min',
        'sport_bets_count_max',
        'sport_bets_count_min',
        'casino_bet_amount_max',
        'casino_bet_amount_min',
        'casino_bets_count_max',
        'casino_bets_count_min',
        'casino_bets_sum_min',
        'casino_bets_sum_max',
        'player_registration_min',
        'player_registration_max',
        'player_activity',
      ])).some((el) => !!el);
    },
    holdRevShare: {
      get() {
        if (this.cpa.hold_seconds === null) {
          return null;
        }

       // const dur = this.$moment.duration(this.cpa.hold_seconds, 'seconds',);
        return getDurationInUnit(this.cpa.hold_seconds, this.holds.dep, 'custom') || 0;
      },
      set(value) {
        if (value || value === 0) {
          // this.cpa.hold_seconds = this.$moment.duration(parseFloat(value), this.holds.dep).asSeconds();
          this.cpa.hold_seconds = getDurationInUnit(parseFloat(value), this.holds.dep, 'seconds');
        } else {
          this.cpa.hold_seconds = null;
        }
      },
    },
  },

  watch: {
    indexRule() {
      this.getPayment();
      this.reloadDataPayload();
      this.holdDur();
      this.holdRev();
    },
    dailyCap: {
      handler(value) {
        // this.cpa.cap_period_seconds = this.$moment.duration(+value, 'days').asSeconds();
        this.cpa.cap_period_seconds = getDurationInUnit(parseFloat(+value), 'days', 'seconds');
      },
    },
  },
  mounted() {
    this.getPayment();
    this.holdDur();
    this.holdRev();
    this.reloadDataPayload();
  },
  methods: {
    holdDur() {
      const duration = intervalToDuration({
        start: new Date(0),
        end: new Date(this.cpa.hold_seconds * 1000),
      });
      Object.keys(duration)
        .forEach((key) => {
          if (duration[key] !== 0) {
            this.holds.dep = key;
          }
        });
      if (this.holds.dep === 'months' || this.holds.dep === 'years') {
        this.holds.dep = 'days';
      }
    },
    holdRev() {
      if (this.holds.rev === 'months' || this.holds.rev === 'years') {
        this.holds.rev = 'days';
      }
    },
    getRuleError(key) {
      const min = this.$_.get(this.errorRule, ['conditions', key, 'min_value']);
      const max = this.$_.get(this.errorRule, ['conditions', key, 'max_value']);

      return {
        min,
        max,
      };
    },
    getConditionsError(path) {
      return this.$_.get(this.errorRule, ['conditions', ...path, 0, 'message']);
    },
    deletePayout() {
      this.$emit('remove-payout');
    },
    reloadDataPayload() {
      this.deposits_count.min = this.cpa.deposits_count_min;
      this.deposits_count.max = this.cpa.deposits_count_max;
      this.deposits_sum.min = this.cpa.deposits_sum_min;
      this.deposits_sum.max = this.cpa.deposits_sum_max;
      this.deposits_amount.min = this.cpa.deposit_amount_min;
      this.deposits_amount.max = this.cpa.deposit_amount_max;
      // sport
      this.sport_bets_count.min = this.cpa.sport_bets_count_min;
      this.sport_bets_count.max = this.cpa.sport_bets_count_max;
      this.sport_bets_sum.min = this.cpa.sport_bets_sum_min;
      this.sport_bets_sum.max = this.cpa.sport_bets_sum_max;
      this.sport_bet_amount.min = this.cpa.sport_bet_amount_min;
      this.sport_bet_amount.max = this.cpa.sport_bet_amount_max;
      this.sport_bets_odd.min = this.cpa.sport_bets_odd_min;
      this.sport_bets_odd.max = this.cpa.sport_bets_odd_max;
      // casino
      this.casino_bets_count.min = this.cpa.casino_bets_count_min;
      this.casino_bets_count.max = this.cpa.casino_bets_count_max;
      this.casino_bets_sum.min = this.cpa.casino_bets_sum_min;
      this.casino_bets_sum.max = this.cpa.casino_bets_sum_max;
      this.casino_bet_amount.min = this.cpa.casino_bet_amount_min;
      this.casino_bet_amount.max = this.cpa.casino_bet_amount_max;
      this.player_registration.min = this.cpa.player_registration_min;
      this.player_registration.max = this.cpa.player_registration_max;

      if (this.cpa.player_activity) {
        this.player_activity = this.$_.cloneDeep(this.cpa.player_activity);
      }

      if (this.cpa.cap_period_seconds !== null) {
        this.dailyCap = durationSecondsToDays(this.cpa.cap_period_seconds);
      }
    },
    getPayment() {
      this.listPayment = [...listPayment];

      const {
        deposits_count_min,
        deposits_count_max,
        deposits_sum_min,
        deposits_sum_max,
        deposit_amount_min,
        deposit_amount_max,
      } = this.cpa;

      if ([
        deposits_count_min,
        deposits_count_max,
        deposits_sum_min,
        deposits_sum_max,
        deposit_amount_min,
        deposit_amount_max].some((el) => !!el)
      ) {
        this.listPayment.splice(this.listPayment.indexOf('deposits'), 1);
      }

      const {
        sport_bets_count_min,
        sport_bets_count_max,
        sport_bets_sum_min,
        sport_bets_sum_max,
        sport_bet_amount_min,
        sport_bet_amount_max,
        sport_bets_odd_min,
        sport_bets_odd_max,
      } = this.cpa;

      if ([
        sport_bets_count_min,
        sport_bets_count_max,
        sport_bets_sum_min,
        sport_bets_sum_max,
        sport_bet_amount_min,
        sport_bet_amount_max,
        sport_bets_odd_min,
        sport_bets_odd_max].some((el) => !!el)
      ) {
        this.listPayment.splice(this.listPayment.indexOf('sport_bets'), 1);
      }

      const {
        casino_bets_count_min,
        casino_bets_count_max,
        casino_bets_sum_min,
        casino_bets_sum_max,
        casino_bet_amount_min,
        casino_bet_amount_max,
      } = this.cpa;
      if ([
        casino_bets_count_min,
        casino_bets_count_max,
        casino_bets_sum_min,
        casino_bets_sum_max,
        casino_bet_amount_min,
        casino_bet_amount_max].some((el) => !!el)
      ) {
        this.listPayment.splice(this.listPayment.indexOf('casino_bets'), 1);
      }

      const { player_registration_min, player_registration_max } = this.cpa;

      if ([player_registration_min, player_registration_max].some((el) => !!el)) {
        this.listPayment.splice(this.listPayment.indexOf('player_registration'), 1);
      }

      const { player_activity } = this.cpa;

      if (isActivityAvailable && player_activity) {
        this.listPayment.splice(this.listPayment.indexOf('player_activity'), 1);
      }
    },
    confirmPayment(v) {
      this.confirm.title = this.$t('affiliates.offer_popup.confirm_payment.title');
      this.confirm.msg = this.$t('affiliates.offer_popup.confirm_payment.msg');
      this.confirm.type = 'warning';
      this.confirm.action = 'payment';
      this.confirm.actionName = this.$t('affiliates.offer_popup.confirm_payment.action');
      this.confirm.closeActionName = '';
      this.confirm.data = v;
      this.$refs.confirm.open();
    },
    confirmPayout() {
      if (this.isDisableDeletePayout) return;

      this.confirm.title = this.$t('affiliates.offer_popup.confirm_cpa_payout.title');
      this.confirm.msg = this.$t('affiliates.offer_popup.confirm_cpa_payout.msg');
      this.confirm.type = 'warning';
      this.confirm.action = 'payout';
      this.confirm.actionName = this.$t('affiliates.offer_popup.confirm_cpa_payout.action');
      this.confirm.closeActionName = '';
      this.$refs.confirm.open();
    },
    deletePayment(v) {
      this.listPayment.push(v);
      if (v === 'deposits') {
        this.cpa.deposits_count_min = null;
        this.cpa.deposits_count_max = null;
        this.cpa.deposits_sum_min = null;
        this.cpa.deposits_sum_max = null;
        this.cpa.deposit_amount_min = null;
        this.cpa.deposit_amount_max = null;
      }
      if (v === 'sport_bets') {
        this.cpa.sport_bets_count_min = null;
        this.cpa.sport_bets_count_max = null;
        this.cpa.sport_bets_sum_min = null;
        this.cpa.sport_bets_sum_max = null;
        this.cpa.sport_bet_amount_min = null;
        this.cpa.sport_bet_amount_max = null;
        this.cpa.sport_bets_odd_min = null;
        this.cpa.sport_bets_odd_max = null;
      }
      if (v === 'casino_bets') {
        this.cpa.casino_bets_count_min = null;
        this.cpa.casino_bets_count_max = null;
        this.cpa.casino_bets_sum_min = null;
        this.cpa.casino_bets_sum_max = null;
        this.cpa.casino_bet_amount_min = null;
        this.cpa.casino_bet_amount_max = null;
      }
      if (v === 'player_registration') {
        this.cpa.player_registration_min = null;
        this.cpa.player_registration_max = null;
      }
      if (v === 'player_activity') {
        this.cpa.player_activity = null;
      }
    },
    actionConfirm(action, type) {
      switch (action) {
      case 'payment':
        this.deletePayment(type);
        this.$refs.confirm.close();
        break;
      case 'payout':
        this.deletePayout(type);
        this.$refs.confirm.close();
        break;
      default:
        break;
      }
    },
    toScroll(elem) {
      setTimeout(() => {
        if (this.$refs) {
          // eslint-disable-next-line no-unused-expressions
          this.$refs[elem]?.scrollIntoView({ behavior: 'smooth' });
        }
      });
    },
    addPayment(item) {
      this.listPayment.splice(this.listPayment.indexOf(item), 1);
      if (item === 'player_activity') {
        this.player_activity = {
          interval_value: null,
          interval_unit: 'hours',
          event_types_group: 'default',
          selected_event_types: [],
        };
        this.$_.set(this.cpa, 'player_activity', this.$_.cloneDeep(this.player_activity));
      }

      this.toScroll(item);
    },
    prepareCpaValue(val) {
      if (val || val === 0) {
        return val;
      }

      return null;
    },
  },
};
</script>

<style lang="scss" scoped>
.cpa-item{
  .ui-select-element {
    min-width: 72px;
    max-width: 80px;
  }
  &__hold-select.ui-select-element{
    min-width: 100px;
  }


  &__payout{
    display: flex;
    align-items: flex-start;
  }
  &__payout-block{
    margin-right: 16px;
    .offer-input-cpa{
      max-width: 90px;
    }
    &:last-child {
      margin-right: 0;
    }
  }
  .offer-input-hold{
    max-width: 134px;
  }
  .offer-input-cpa_day {
    font-size: 13px;
    max-width: 110px;
    &:deep(.input-post-text) {
      padding: 0 4px;
    }
  }
}

.remove-payout.disabled {
  opacity: .5;
  cursor: not-allowed;
}
.container {
  background-color: #f4f7fa;
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 10px;
}
.payment-card {
  margin-top: 12px;
  background-color: #e3e8ef!important;
}

.notification {
  display: flex;
  padding: 12px 16px 12px 12px;
  border-radius: 8px;
  font-size: 13px;
  background-color: var(--palette-status-negative-subtle);
  color: var(--text-negative);
  margin-top: 8px;
}

.title-wrap {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .title {
    font-size: 16px;
    font-weight: 500;
    color: #303634;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
  }
}

.card-filter__label {
  white-space: nowrap;
}
</style>
